import { render } from "./clearIcon.vue?vue&type=template&id=64532107"
import script from "./clearIcon.vue?vue&type=script&lang=js"
export * from "./clearIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__